module.exports = __webpack_public_path__ + "img/540.c25f17b6.jpg";